import React, { useEffect, useState, Fragment } from "react";
import style from "./index.module.scss";
import { Table } from "antd";
import "@jdcfe/legao/dist/@jdcfe/legao.css";
import "./reset-legao.scss";
export interface IAppProps {
  list: any;
  navIcon: string;
  perm_list: any;
}
const App: React.SFC<IAppProps> = props => {
  const { list, navIcon, perm_list: permList } = props;
  const tableDataKeys = ["permPackageId", "permPackageName", "permPackageDesc"];
  const [currentId, setCurrentId] = useState(list && list[0] ? list[0].id : "");
  useEffect(() => {
    window.onscroll = () => {
      list.map(item => {
        const el = document.querySelector("#" + item.id);
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollHeight > clientHeight && scrollTop + clientHeight === scrollHeight) {
          // if (list[index + 1]) {
          //   setCurrentId(list[index + 1].id);
          // }
          return;
        }
        if (el && scrollTop > el.getBoundingClientRect().top + window.pageYOffset - 1) {
          setCurrentId(item.id);
        }
      });
    };
  }, []);
  return (
    <div className={`${style.app}`}>
      <div className={style.left}>
        <ul>
          {list.map((item: { mainTitle; link; id }, index) => (
            <li key={index}>
              {currentId === item.id && <em style={{ background: `url(${navIcon}) no-repeat 0 0 / cover` }} />}
              <a
                className={currentId === item.id ? style.current : ""}
                onClick={() => {
                  // window.location.href = "#" + item.id;
                  window.scrollTo(
                    0,
                    document.querySelector("#" + item.id).getBoundingClientRect().top + window.pageYOffset,
                  );
                  setCurrentId(item.id);
                }}
              >
                {item.mainTitle}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <ul className={style.right}>
        {list.map((item: { mainTitle: string; btns; subTitleAndDesc; tableData; figure; links; id }) => (
          <Fragment key={item.id}>
            <li id={item.id}>
              <h1 className={style.mainTitle}>{item.mainTitle}</h1>
              <ul>
                {item.subTitleAndDesc &&
                  item.subTitleAndDesc.map((subTitleAndDesc, index) => (
                    <li key={index} className={style.subTitleWrapper}>
                      {subTitleAndDesc.subTitle && <p className={style.subTitle}>{subTitleAndDesc.subTitle}</p>}
                      {subTitleAndDesc.paragraph && (
                        <div
                          className="text-editor-box"
                          dangerouslySetInnerHTML={{ __html: subTitleAndDesc.paragraph }}
                        ></div>
                      )}
                      {subTitleAndDesc.picture && subTitleAndDesc.showPicture && (
                        <img src={subTitleAndDesc.picture} alt="" />
                      )}
                    </li>
                  ))}
                {item.btns &&
                  item.btns[0].link &&
                  item.btns.map((btn, index) => (
                    <li key={index} className={style.btnWrapper}>
                      <button onClick={() => (window.location.href = btn.link)} className={style.btn}>
                        {btn.text}
                      </button>
                    </li>
                  ))}
                {item.tableData &&
                  item.tableData[0] &&
                  item.tableData[0].columns &&
                  item.tableData[0].columns[0].title &&
                  permList &&
                  permList.data &&
                  permList.data.code === 200 && (
                    <li>
                      <Table
                        columns={item.tableData[0].columns.map((item, index) => {
                          return {
                            ...item,
                            ...{ key: tableDataKeys[index], dataIndex: tableDataKeys[index] },
                            render:
                              tableDataKeys[index] === "permPackageName"
                                ? (text, item) => {
                                    return (
                                      <a
                                        href={`//${window.location.host}/apilist?apiGroupId=${item.permPackageId}&apiGroupName=${item.permPackageName}`}
                                      >
                                        {text}
                                      </a>
                                    );
                                  }
                                : null,
                          };
                        })}
                        rowKey={r => r.permPackageId}
                        dataSource={permList.data.data}
                      />
                    </li>
                  )}
                {item.figure &&
                  item.figure[0] &&
                  item.figure[0].picture &&
                  item.figure[0].desc[0] &&
                  item.figure[0].desc[0].mainTitle &&
                  item.figure.map((item, index) => (
                    <li key={index} className={style.figure}>
                      <img src={item.picture} alt="" />
                      {item.desc.map((item, index) => (
                        <div key={index} className={style.caption}>
                          <div>
                            <p className={style.title}>{item.mainTitle}</p>
                            <p className={style.detail}>{item.detail}</p>
                          </div>
                          <img src={item.logo} alt="" />
                        </div>
                      ))}
                    </li>
                  ))}
                {item.links &&
                  item.links[0].text &&
                  item.links.map((item, index) => (
                    <li className={style.question} key={index}>
                      <em
                        style={{
                          background: `url(${item.logo}) no-repeat 0 0 / cover`,
                        }}
                      />
                      <a href={item.link}>{item.text}</a>
                    </li>
                  ))}
              </ul>
            </li>
            <hr />
          </Fragment>
        ))}
      </ul>
    </div>
  );
};

export default App;
